<script setup lang="ts">
import { CarOfferWidgetType } from '@xcel-next/core/enums'

import type { ComposedCarOfferWidgetBuy, ComposedCarOfferWidgetLease } from '@xcel-next/composer-schema'

withDefaults(defineProps<{
  type?: CarOfferWidgetType
  expired?: boolean
  buy?: ComposedCarOfferWidgetBuy
  lease?: ComposedCarOfferWidgetLease
}>(), {
  expired: false
})

const formatPrice = (value?: number): string => value ? value.toLocaleString('de-DE') : ''
</script>

<template>
  <div :class="{
    'bx-carwow__prices': true,
    'bx-carwow__prices--lease': type === CarOfferWidgetType.lease,
    'bx-carwow__prices--expired': expired,
  }">
    <template v-if="expired">
      <div class="bx-carwow__price-main">
        Abgelaufen
      </div>
    </template>
    <template v-else-if="(lease?.rate ?? 0) > 0">
      <div class="bx-carwow__price-meta">
        <span>Leasingfaktor</span>
        <span>{{ lease?.factor }}</span>
      </div>
      <div class="bx-carwow__price-main">
        {{ formatPrice(lease?.rate) }}€ / Monat
      </div>
    </template>
    <template v-else-if="(buy?.price ?? 0) > 0">
      <div class="bx-carwow__price-meta">
        statt {{ formatPrice(buy?.strikePrice) }} €
      </div>
      <div class="bx-carwow__price-main">
        {{ formatPrice(buy?.price) }}€
        <span v-if="buy?.savings?.percent">-{{ buy?.savings?.percent }}%</span>
      </div>
    </template>
  </div>
</template>
